<div class="address-container ya-typography" (click)="handleDisplayList($event)">
  <ya-subheader [hasContent]="true"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <span class="header-title" langkey="phAddress_Required_Header"></span>
    <div class="ya-form-wrapper">
      <div class="input-content--grid">
        <div class="content text--zip-code">
          <input a11y_Input type="text" class="ya-input-text" (blur)="setWebviewAfterBlur(); handleZipCodeBlur()"
            [placeholder]="getInputPlaceholder(field.ZipCode)" [formControl]="ZipCodeFormControl"
            [attr.maxlength]="orderDataInputMaxLength.zip_code" />
          <ng-container *ngIf="hasControlErrorAndErrorLabel(ZipCodeFormControl, field.ZipCode)">
            <span class="error-label">{{getActiveErrorLabel(field.ZipCode)}}</span>
          </ng-container>
        </div>
        <div class="content text--city" (click)="$event.stopPropagation()">
          <input a11y_Input type="text" class="ya-input-text" [placeholder]="getInputPlaceholder(field.City)"
            [formControl]="CityFormControl" (focus)="displayCityList = !userIsLoggedIn" (blur)="setWebviewAfterBlur()"
            [attr.maxlength]="orderDataInputMaxLength.city" />
          <ng-container *ngIf="displayCityList && cityList.length > 0">
            <div class="dropdown-content" (click)="$event.stopPropagation()">
              <ng-container *ngFor="let city of cityList">
                <div class="list_item--city" (click)="selectCity(city); displayCityList = false">
                  {{ city }}
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="hasControlErrorAndErrorLabel(CityFormControl, field.City)">
            <span class="error-label">{{getActiveErrorLabel(field.City)}}</span>
          </ng-container>
        </div>
        <div class="content text--street">
          <input a11y_Input type="text" class="ya-input-text" (blur)="setWebviewAfterBlur()"
            [placeholder]="getInputPlaceholder(field.Street)" [formControl]="StreetFormControl"
            [attr.maxlength]="deliveryAddressQueryMaxLength.street" />
          <ng-container *ngIf="hasControlErrorAndErrorLabel(StreetFormControl, field.Street)">
            <span class="error-label">{{getActiveErrorLabel(field.Street)}}</span>
          </ng-container>
        </div>
        <div class="content text--number">
          <input a11y_Input type="text" class="ya-input-text" (blur)="setWebviewAfterBlur()"
            [placeholder]="getInputPlaceholder(field.HouseNumber)" [formControl]="HouseNumberFormControl"
            [attr.maxlength]="deliveryAddressQueryMaxLength.houseNumber" />
          <ng-container *ngIf="hasControlErrorAndErrorLabel(HouseNumberFormControl, field.HouseNumber)">
            <span class="error-label">{{getActiveErrorLabel(field.HouseNumber)}}</span>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="hasMultipleAddresses()||(userIsLoggedIn&&usePostalCodeSuggestion)">
        <div class="address-list">
          <div class="address-list-header">
            <span class="header-title" langkey="phAddress_Required_Alternative_Addresses"></span>
          </div>
          <div class="address-selector">
            <div class="ya-radio-group-vertical">
              <ng-container *ngFor="let address of userAddressList">
                <mat-radio-button #radioButton [disableRipple]="true" [value]="address.id"
                  (change)="onAddressSelectionChange(address.id)"
                  [checked]="isCitySelectedById(address.id,radioButton)">
                  {{ displayUserAddressListItem(address) }}
                </mat-radio-button>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="ya-webshop-button-container">
        <ng-container *ngIf="addressDataValid(); then activeButton; else inActiveButton"></ng-container>
        <ng-template #activeButton>
          <button mat-flat-button (click)="onConfirmAddressData()">
            <span langkey="phGlobal_Continue"></span>
          </button>
        </ng-template>
        <ng-template #inActiveButton>
          <button mat-flat-button disabled>
            <span langkey="phGlobal_Continue"></span>
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</div>